module.exports = __webpack_public_path__ + "img/title.f15e40ba.png";